import React from "react";
import { useNavigate } from "react-router-dom";
import MOCK_PERSONNEL from "../../../mockData/mockPersonnelData";

// Helper function to calculate relative time
const getRelativeTime = (lastUpdated) => {
  // Parse the timestamp (format: "2026-04-23 14:32")
  const updateTime = new Date(lastUpdated.replace(" ", "T"));
  const currentTime = new Date("2026-04-23T14:32:00"); // Using a fixed reference time from mock data

  const diffMs = currentTime - updateTime;
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return "just now";
  if (diffMins === 1) return "1 minute ago";
  if (diffMins < 60) return `${diffMins} minutes ago`;

  const diffHours = Math.floor(diffMins / 60);
  if (diffHours === 1) return "1 hour ago";
  return `${diffHours} hours ago`;
};

const ActivePersonnel = () => {
  const navigate = useNavigate();

  const handleRowClick = (fullName) => {
    // Navigate to Personnel Metrics page with fullName as URL param
    navigate(`/personnel-metrics?name=${encodeURIComponent(fullName)}`);
  };

  return (
    <>
      <p className="modal-description">
        Employees with location updates in the last 30 minutes
      </p>

      <div className="modal-section modal-section--scroll">
        <h3>Currently Active</h3>
        <div className="modal-table-scroll">
          <table className="modal-table modal-table--clickable">
            <thead>
              <tr>
                <th>Employee Name</th>
                <th>Current Job</th>
                <th>Last Updated Position</th>
              </tr>
            </thead>
            <tbody>
              {MOCK_PERSONNEL.map((employee) => (
                <tr
                  key={employee.employeeId}
                  onClick={() => handleRowClick(employee.fullName)}
                  className="modal-table-row--clickable"
                  title="Click to view personnel details"
                >
                  <td>{employee.fullName}</td>
                  <td>{employee.currentJob}</td>
                  <td>{getRelativeTime(employee.lastUpdated)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ActivePersonnel;
